import type React from 'react';

import { GooglePlacesProvider } from '#src/app/shared/hooks/googlePlacesV2';

import type { PlaceWithDetailsFieldProps } from './PlaceWithDetailsField';
import { PlaceWithDetailsField } from './PlaceWithDetailsField';

export const PlaceWithDetailsFieldWrapper: React.FC<PlaceWithDetailsFieldProps> = (props) => {
	return (
		<GooglePlacesProvider>
			<PlaceWithDetailsField {...props} />
		</GooglePlacesProvider>
	);
};
